import { StudentDebtNotificationType } from "../../types/Finance";
import { PagedRequestType, PagedResultsType } from "../../types/PagedResults";
import { get, post, put } from "../../utils/axios-config";
import { STUDENT_DEBTS_NOTIFICATIONS } from "../../utils/constants";

export const createStudentDebtNotification = async (data: StudentDebtNotificationType) => await post<StudentDebtNotificationType, string>(STUDENT_DEBTS_NOTIFICATIONS, data);
export const updateStudentDebtNotification = async (data: StudentDebtNotificationType) => await put<StudentDebtNotificationType, string>(STUDENT_DEBTS_NOTIFICATIONS, data);
export const getStudentDebtNotifications = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        ...(data?.IdStudent ? { IdStudent: data.IdStudent } : {}),
        ...(data?.IdStudentDebt ? { IdStudent: data.IdStudent } : {}),
        ...(data?.IdPaymentType ? { IdPaymentType: data.IdPaymentType } : {}),
    });
    const url = `${STUDENT_DEBTS_NOTIFICATIONS}?${queryParams.toString()}`;
    return await get<PagedResultsType<StudentDebtNotificationType>>(url)
};